/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_YellowInputs */

const en_booking_color_yellow = /** @type {(inputs: Booking_Color_YellowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yellow`)
};

const pl_booking_color_yellow = /** @type {(inputs: Booking_Color_YellowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żółty`)
};

/**
* | output |
* | --- |
* | "Yellow" |
*
* @param {Booking_Color_YellowInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_yellow = /** @type {((inputs?: Booking_Color_YellowInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_YellowInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_yellow(inputs)
	return en_booking_color_yellow(inputs)
});